import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const MarkedText = styled('mark')`
  padding: 8px;
  background: ${({ theme }) => theme.color.chart02};
  border-radius: 8px;
  margin: ${({ theme }) => `${theme.x1spacePx}px auto 0`};
  padding: ${({ theme }) => `${theme.x1spacePx}px ${theme.x2spacePx}px`};
  display: table;
  ${({ theme }) => theme.typography.xSmall}
`;

export const MarkedTextContainer = styled('div')`
  padding: 0 ${({ theme }) => theme.x3spacePx}px;
  text-align: center;
  min-height: 45px;
  margin-top: ${({ theme }) => theme.x5spacePx}px;
`;

interface AddedFeaturesProps {
  darkBackground: boolean;
}
export const AddedFeatures = styled('ul')<AddedFeaturesProps>`
  width: fit-content;
  margin: 0 auto;
  color: ${({ theme }) => theme.color.spaceGrayRGBA(0.7)};
  width: 100%;
  text-align: left;
  ${({ theme }) => theme.typography.base}
  padding: 28px 0 18px;
  ${media.mdUp`
    text-align: center;
    padding: 35px 0 18px;
  `}
  > li {
    padding-left: ${({ theme }) => theme.x3spacePx}px;
    ${media.mdUp`
      display: inline;
    `}
  }
  ${({ darkBackground }) =>
    darkBackground &&
    css`
      li {
        color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
        svg {
          fill: ${({ theme }) => theme.color.white};
        }
      }
    `}
`;

interface FeatureItemProps {
  notIncluded: boolean;
}
export const FeatureItem = styled('li')<FeatureItemProps>`
  ${({ theme }) => theme.typography.small}
  ${({ notIncluded }) => notIncluded && 'opacity: 0.5;'}
  padding: 4px 0 0 0;
  width: fit-content;
  svg {
    fill: ${({ theme, notIncluded }) =>
      notIncluded ? theme.color.charcoalRGBA(1) : theme.color.brand01};
    vertical-align: middle;
    margin-right: 0.8rem;
    margin-bottom: 2px;
    width: 2.4rem;
  }
  div {
    display: flex;
  }
`;
